import * as React from "react";
const SvgCheckIcon = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m8.25 11.839 2.696 2.695 4.805-5.069", stroke: "#fff", strokeWidth: 1.4, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgCheckIcon;
